import expScript from "src/expScript";

import { precedingJsContext } from "src/module/kzs";

const kzExternalExpScript = (context: precedingJsContext) => {
  return expScript(context);
};
window.kzExternalExpScript = kzExternalExpScript;
window.kzs.console.log("kzExternalExpScript Loaded");
